import { root, id } from './tags';

export const tags = {
  ...root,
  id,
};
